module.exports = __webpack_public_path__ + "static/virtual_cards-9b189bac34e885c3f88bc1a537848fec.png";